import React from 'react'
import { InfoModal } from 'asterX-UI/Modals'
import { SessionStorageService } from 'lib/utils'
import { HOME_PATH } from 'routes/constants.routes'
import { withRouter } from 'react-router'
import { GRAY_COLORS } from './colors.constant'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: { message: '', stack: '' },
      info: { componentStack: '' }
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, info: errorInfo })
  }

  onClose = () => {
    const { history } = this.props
    const prevPage = SessionStorageService.getPrevPage()
    const pathname = window.location.pathname

    history.push(prevPage === pathname ? HOME_PATH : prevPage)
    this.setState({ error: null, info: null, hasError: false })
  }
  render() {
    const { hasError, error, info } = this.state
    if (hasError) {
      // Error path
      return (
        <InfoModal
          open={hasError}
          variant={'info'}
          title={'Произошла ошибка !'}
          onClose={this.onClose}
          btnText={'Закрыть'}
        >
          <div
            style={{
              whiteSpace: 'pre-wrap',
              background: GRAY_COLORS[300],
              borderRadius: 5,
              overflowY: 'auto',
              maxWidth: 367,
              maxHeight: 320,
              overflowWrap: 'break-word',
              padding: 10
            }}
          >
            {error && error.toString()}
            <br />
            {info.componentStack}
          </div>
        </InfoModal>
      )
    }

    return this.props.children
  }
}
export default withRouter(ErrorBoundary)
